/* eslint-disable no-unused-vars */
import React, { useMemo, useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { addFieldStatus, showPolipop, trimObjectValues, formDataFromObject } from 'utils';
import { useNavigate } from 'react-router-dom';
import * as S from './GeneralSettingsForm.styled';
import { CustomInput, CopyString, Upload, Buttons, FileUploader, Loader } from 'components';
import { routes } from 'config';
import { manageAppsAPI } from 'services/manageApps.service';
import { isAdminSelector } from 'store/selectors';
import { useSelector } from 'react-redux';
import { isEqual } from 'lodash-es';
let timer_id;

function trancDoubleSpace(value) {
  return value.replaceAll('  ', ' ');
}

const GeneralSettingsForm = ({ previewData, isFetching, isLoading }) => {
  const navigate = useNavigate();
  //const isAdmin = useSelector(isAdminSelector);
  const isAdmin = false;

  const [upDateAppData, result] = manageAppsAPI.useUpdateAppDataMutation();
  const [redirect, setRedirect] = useState(false);
  const {
    handleSubmit,
    reset,
    watch,
    control,
    getValues,
    setValue,
    formState: { errors, isDirty },
  } = useForm({
    mode: 'onChange',
    defaultValues: previewData,
  });

  const formValues = getValues();

  const { pba_id, package_id, category, pba_url, app_type_assoc } = previewData;
  const isWebsiteApp = !!app_type_assoc;

  const onSubmit = async (data) => {
    let newDate = trimObjectValues(data);

    if (typeof data.file === 'string') {
      newDate = {
        ...newDate,
        file: null,
      };
    }

    const res = await upDateAppData(
      formDataFromObject({ ...newDate, pba_id, package_id, categories: category }),
    );

    return res;
  };

  const link = routes.list.find((route) => route.id === 'manageApps').url;

  const goToManageApps = () => {
    navigate(link);
  };

  const handleSaveAndClose = () => {
    handleSubmit();
    setRedirect(true);
  };
  const errorAction = () => {};
  const successAction = () => {
    reset(watch(), { keepDirtyValues: false });
  };

  const onCloseAction = () => {};

  useEffect(() => {
    showPolipop(result, successAction, errorAction, onCloseAction);
    if (redirect && result.isSuccess) {
      timer_id = setTimeout(() => {
        goToManageApps();
        reset(watch());
      }, 2500);
    }
    return () => {
      clearTimeout(timer_id);
    };
  }, [result]);

  return (
    <S.Container>
      {result.isLoading && <Loader.Global delay={1000} />}
      <S.Form onSubmit={handleSubmit(onSubmit)} id='generallsettings'>
        <S.Box>
          <S.Head>General Settings</S.Head>
          <S.Field>
            <S.LabelWrapper>
              <label>{isWebsiteApp ? 'Website name:' : 'App name:'}</label>
            </S.LabelWrapper>
            <S.InputWrapper>
              <Controller
                // defaultValue={formValues?.pba_name}
                rules={{
                  required: 'This is required',
                  validate: (value) => {
                    return !!value.trim() || 'This is required';
                  },
                }}
                name={'pba_name'}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <CustomInput
                    id='pba_name'
                    name={'pba_name'}
                    onChange={onChange}
                    value={trancDoubleSpace(value)}
                    errorText={errors?.pba_name?.message}
                    error={errors?.pba_name && errors?.pba_name?.type === 'required'}
                    containerStyle={{ marginBottom: '8px' }}
                  />
                )}
              />
              <CopyString label='Package ID' text={formValues?.package_id} />
            </S.InputWrapper>
          </S.Field>
          {isWebsiteApp && (
            <S.Field>
              <S.LabelWrapper>
                <label>Website URL:</label>
              </S.LabelWrapper>
              <S.InputWrapper>{pba_url}</S.InputWrapper>
            </S.Field>
          )}
          <S.Field>
            <S.LabelWrapper>
              <label>Category:</label>
            </S.LabelWrapper>
            <S.InputWrapper>{category}</S.InputWrapper>
          </S.Field>
          <S.Field position='top'>
            <S.LabelWrapper>
              <label>App Icon:</label>
              <S.Requirements>
                JPEG or PNG.
                <br />
                Please upload image size 512*512
              </S.Requirements>
            </S.LabelWrapper>
            <S.UploadWrapper>
              <Controller
                rules={{ required: 'This is required' }}
                defaultValue={formValues?.image_url}
                name={'file'}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <Upload
                    accept='image/jpeg, image/jpg, image/png, image/gif'
                    value={value}
                    id='file'
                    size={Upload.Size?.Big}
                    onChange={onChange}
                    maxWidth={512}
                    maxHeight={512}
                    errorText={errors?.file?.message}
                    error={errors?.file && errors?.file?.type === 'required'}
                  />
                )}
              />
            </S.UploadWrapper>
          </S.Field>
          {isAdmin ? (
            <S.Field position='top'>
              <S.LabelWrapper>
                <label>APK</label>
                <S.Requirements></S.Requirements>
              </S.LabelWrapper>
              {/* <S.UploadWrapper> */}
              <div style={{ width: '75%' }}>
                <Controller
                  defaultValue={formValues?.apk}
                  name={'apk'}
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <FileUploader
                      value={value}
                      id='apk'
                      availableTypes={['zip', 'apk']}
                      alertMessage='Please select a APK or ZIP file up to 60 MB in size.'
                      accept='.apk, .zip'
                      onChange={onChange}
                    />
                  )}
                />
              </div>
              {/* </S.UploadWrapper> */}
            </S.Field>
          ) : null}
        </S.Box>
        <S.BtnGroup>
          <Buttons.PrimaryNormal
            id='saveButton'
            type='submit'
            isDisabled={!isDirty || Object.keys(errors).length > 0}
            onClick={handleSubmit}
          >
            Save Settings
          </Buttons.PrimaryNormal>
          <Buttons.SecondaryNormal
            id='saveAndCloseButton'
            type='submit'
            isDisabled={!isDirty || Object.keys(errors).length > 0}
            onClick={handleSaveAndClose}
          >
            Save & Close
          </Buttons.SecondaryNormal>
          <Buttons.SecondaryNormal id='cancelButton' onClick={goToManageApps}>
            Cancel
          </Buttons.SecondaryNormal>
        </S.BtnGroup>
      </S.Form>
    </S.Container>
  );
};

export default GeneralSettingsForm;
